/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recovery_Rest_TomorrowInputs */

const en_us2_recovery_rest_tomorrow = /** @type {(inputs: Recovery_Rest_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tomorrow`)
};

const pt_br2_recovery_rest_tomorrow = /** @type {(inputs: Recovery_Rest_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`amanhã`)
};

const es_419_recovery_rest_tomorrow = /** @type {(inputs: Recovery_Rest_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mañana`)
};

const pt_pt2_recovery_rest_tomorrow = /** @type {(inputs: Recovery_Rest_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`amanhã`)
};

const fr_fr2_recovery_rest_tomorrow = /** @type {(inputs: Recovery_Rest_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`demain`)
};

const de_de2_recovery_rest_tomorrow = /** @type {(inputs: Recovery_Rest_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`morgen`)
};

const it_it2_recovery_rest_tomorrow = /** @type {(inputs: Recovery_Rest_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`domani`)
};

/**
* | output |
* | --- |
* | "tomorrow" |
*
* @param {Recovery_Rest_TomorrowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const recovery_rest_tomorrow = /** @type {((inputs?: Recovery_Rest_TomorrowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recovery_Rest_TomorrowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_recovery_rest_tomorrow(inputs)
	if (locale === "es-419") return es_419_recovery_rest_tomorrow(inputs)
	if (locale === "pt-PT") return pt_pt2_recovery_rest_tomorrow(inputs)
	if (locale === "fr-FR") return fr_fr2_recovery_rest_tomorrow(inputs)
	if (locale === "de-DE") return de_de2_recovery_rest_tomorrow(inputs)
	if (locale === "it-IT") return it_it2_recovery_rest_tomorrow(inputs)
	return en_us2_recovery_rest_tomorrow(inputs)
});
export { recovery_rest_tomorrow as "recovery.rest_tomorrow" }